<template>
  <el-card>
    <el-form label-width="100px" label-position="right">
      <el-form-item label="入库单号" prop="projectId">
        {{ formData.storageNum }}
      </el-form-item>
      <el-form-item label="项目名称" prop="projectId">
        {{ formData.projectName }}
      </el-form-item>
      <el-form-item label="入库日期" prop="storageDate">
        {{ formData.storageDate }}
      </el-form-item>
      <el-form-item label="入库说明" prop="storageExplain">
        {{ formData.storageExplain }}
      </el-form-item>
      <el-form-item label="入库物料明细"></el-form-item>
      <el-table class="global-table material-table" :data="formData.detailedList">
        <el-table-column label="物料分类" prop="materialTypeName"></el-table-column>
        <el-table-column label="物料名称" prop="materialName"></el-table-column>
        <el-table-column label="规格型号" prop="specifications"></el-table-column>
        <el-table-column label="品牌名称" prop="brand"></el-table-column>
        <el-table-column label="单价" prop="unitPrice"></el-table-column>
        <el-table-column label="单位" prop="company"></el-table-column>
        <el-table-column label="供应商名称" prop="supplierName"></el-table-column>
        <el-table-column label="入库数量" prop="operationStock"></el-table-column>
        <el-table-column label="入库仓库" prop="warehouseName"></el-table-column>
      </el-table>
      <div class="imgList" >
            <span>入库图片</span>
            <div v-if="formData?.imgList?.length" class="ListBox">
              <div class="imgItem" v-for="(item, key) in formData.imgList" :key="key">
                <el-image
                  :src="item.filePrefix + item.fileUrl"
                  :preview-src-list="formData.imgList | previewList"
                  fit="fill">
                </el-image>
              </div>
            </div>
            <div v-else>--</div>
      </div>
      <el-form-item label="入库文件">
        <span v-if="formData?.fileList?.length" style="color:blue;cursor: pointer;" @click="onDownload">{{ formData?.fileList[0]?.fileName }}</span>
        <span v-else >--</span>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'WarehousingDetail',
  components: {
  },
  filters: {
    previewList: function (value) {
      return value.map((item) => {
        return item.filePrefix + item.fileUrl
      })
    }
  },
  props: {},
  data () {
    return {
      formData: {
        projectId: '',
        storageDate: '',
        storageExplain: '',
        detailedList: []
      }
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.material.selectYhStorageById, {
        id: this.id
      }).then(res => {
        this.formData = res
      })
    },
    // 下载
    onDownload () {
      const row = this.formData.fileList
      window.location.href = `${row[0].filePrefix + row[0].fileUrl}?attname=${row[0].fileName}`
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";
    .imgList{
        display: flex;
        margin: 20px 0;
        span{
          display: inline-block;
          width: 100px;
          text-align: right;
          font-size: 14px;
          padding-right: 12px;
        }
        .ListBox{
          flex: 1;
          display: flex;
          flex-wrap:wrap;
          .imgItem{
            width: 102px;
            height: 102px;
            margin:  0 10px 10px 0;
            .el-image,img,video{
              width: 100%;
              height: 100%;
            }
          }
        }
    }
</style>
